import { RESOURCE_DOMAIN } from "@plugins/common/constant/resource.constant.ts";
import { MEDIA_TYPE } from "@modules/search/service/search.constant.ts";

const getCssClasses = (resourceDomain) => {
  return [
    {
      moe: checkIfMoe(resourceDomain),
      community: checkIfCommunity(resourceDomain),
    },
  ];
};

const getSubjectLevelCommas = (index, subjectListLength) => {
  return index < subjectListLength - 1 ? ", " : "";
};

const checkIfMoe = (resourceDomain) => {
  return resourceDomain === RESOURCE_DOMAIN.MOE;
};

const checkIfCommunity = (resourceDomain) => {
  return resourceDomain === RESOURCE_DOMAIN.COMMUNITY;
};

const getSrc = (
  resourceType: string,
  fileUrl: string | undefined,
  thumbnailUrl: string | undefined,
) => {
  if (resourceType === MEDIA_TYPE.IMAGE) {
    return fileUrl;
  } else if (resourceType === MEDIA_TYPE.VIDEO) {
    return thumbnailUrl;
  } else {
    return null;
  }
};

export default {
  getCssClasses,
  getSubjectLevelCommas,
  checkIfMoe,
  checkIfCommunity,
  getSrc,
};
